module.exports = __webpack_public_path__ + "components/flag/static/square/jm-147e2fdb8c37cc75dd69d868fbe6f4be.svg";